import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Chat from '../components/Chat';
import { searchListings, ChatMessage } from '../services/api';

export default function HomePage() {
  const navigate = useNavigate();
  const [isSearching, setIsSearching] = useState(false);

  async function handleProfileComplete(profile: any, messages: ChatMessage[]) {
    setIsSearching(true);

    try {
      // Store profile and messages in sessionStorage
      sessionStorage.setItem('searchProfile', JSON.stringify(profile));
      sessionStorage.setItem('chatMessages', JSON.stringify(messages));

      // Run the search
      const results = await searchListings(profile);
      sessionStorage.setItem('searchResults', JSON.stringify(results));

      // Navigate to results
      navigate('/results');
    } catch (err: any) {
      console.error('Search failed:', err);
      alert('Suche fehlgeschlagen: ' + (err.message || 'Unbekannter Fehler'));
    }

    setIsSearching(false);
  }

  return (
    <div className="home-page">
      {/* Hero */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Finden Sie Ihr perfektes Zuhause
          </h1>
          <p className="hero-subtitle">
            Erzählen Sie uns von Ihrem Leben – wir finden die passende Immobilie.
            Unser AI-gestütztes Interview versteht Ihre Wünsche und findet
            die besten Treffer in der Schweiz.
          </p>
        </div>
      </section>

      {/* Chat Interview */}
      <section className="chat-section">
        <Chat onProfileComplete={handleProfileComplete} />

        {isSearching && (
          <div className="search-loading">
            <div className="spinner" />
            <p>Suche wird durchgeführt...</p>
          </div>
        )}
      </section>
    </div>
  );
}
